import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../../../apiservice/apis";
import {
  getPurchaseReturnedItemsApi,
  getPurchasereturnVoucherApi,
  purchaseRecordnWithDetailsApi,
  purchaseReturnWithDetailsApi,
} from "../../../../apiservice/purchase";
import { createPurchaseReturnPayload } from "../../../../utils/purchaseReturn";
import {
  getAccountBySeachApi,
  getInvoiceBySeachApi,
} from "../../../../apiservice/setting";
import { pathSpliter } from "../../../../lib/functions";
import { getCurrentStockApi } from "../../../../apiservice/sales";

// Voucher number
export const fetchPurchaseReturnNumber = createAsyncThunk(
  "purchaseReturn/fetchNumber",
  async (val) => {
    const res = await getPurchasereturnVoucherApi({ entryDate: val });
    return res.data;
  }
);

export const fetchSupplierInvoices = createAsyncThunk(
  "purchaseReturn/fetchSupplierInvoices",
  async ({ supplierId, searchTerm }, { rejectWithValue }) => {
    try {
      const res = await getInvoiceBySeachApi({
        value: searchTerm || "",
        sup_id: supplierId,
      });

      // const combinedValues = res.data
      //   .flatMap((item) => [
      //     item.pur_invoice_no && {
      //       label: item.pur_invoice_no,
      //       value: item.pur_invoice_no,
      //       pur_id: item.pur_id,
      //     },
      //     item.pur_voucher_no && {
      //       label: item.pur_voucher_no,
      //       value: item.pur_voucher_no,
      //       pur_id: item.pur_id,
      //     },
      //   ])
      //   .filter(Boolean);

      const combinedValues = res.data.map((item) => ({
        label: `${item.pur_voucher_no} ${item.pur_invoice_no ? `(${item.pur_invoice_no})` : ""
          }`, // e.g. "PE002 (2025-09-05 15:03:57)"
        value: item.pur_id,
        pur_id: item.pur_id,
        raw: item,
      }));

      return combinedValues;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Accounts
export const fetchPurchaseReturnAccs = createAsyncThunk(
  "purchaseReturn/fetchAccs",
  async () => {
    const res = await getAccountBySeachApi({
      multiType: ["purchase_return"],
    });
    return res.data;
  }
);

//Fetch selected invoice data
export const fetchInvoiceItemsForReturn = createAsyncThunk(
  "purchaseReturn/fetchInvoiceItemsForReturn",
  async (pur_id, { rejectWithValue }) => {
    try {
      const returnRes = await getPurchaseReturnedItemsApi({ pur_id });
      const returnItems = returnRes.data;

      const detailsRes = await purchaseRecordnWithDetailsApi({ pur_id });
      const data = detailsRes.data?.[0];
      const dataDetails = data?.details || [];

      if (!data) throw new Error("No purchase details found");

      // const parentSsccCode = data.sscc_code || '';
      const parentSsccCode = ''; // Empty - user will enter new
      const average_rate_type = data.apply_discount_to_avg_price;

      // Supplier info
      const supplier = {
        acc_id: data.acc_id,
        acc_name: data.acc_name,
        institution_name: data.institution_name,
        contact_no: data.contact_no,
        address: data.address,
      };

      const otherServiceTrans = detailsRes.otherServiceTrans;

      const totalItemCost = dataDetails.reduce(
        (sum, item) => sum + (Number(item.item_total) || 0),
        0
      );

      // Build itemCart with available qty
      const itemCart = await Promise.all(
        dataDetails.map(async (item) => {
          const stockRes = await getCurrentStockApi({
            itemId: item.item_id,
            warehouseId: 0,
          });
          const stockData = stockRes?.data?.[0];
          const current_qty = stockData?.current_qty || 0;

          const match = returnItems.find((r) => r.item_id === item.item_id);
          const inv_qty = match
            ? item.pur_qty - match.total_return_qty
            : item.pur_qty;

          const available_qty =
            inv_qty > current_qty
              ? // && is_minus_stock_sale == "no"
              current_qty
              : inv_qty;

          const itemTotal = Number(item.item_total);
          const itemQty = Number(item.item_qty);
          const itemShare = totalItemCost ? itemTotal / totalItemCost : 0;

          const otherServiceTransactions = (data.otherServiceTrans || []).map(
            (service) => {
              const serviceAmount = Number(service.tran_amount);
              const itemServiceTotal = itemShare * serviceAmount;
              const perUnitService = itemQty ? itemServiceTotal / itemQty : 0;

              return {
                to_acc_id: service.to_acc_id,
                service_name: service.to_acc_name,
                service_amount_total: itemServiceTotal.toFixed(2),
                service_amount_per_unit: perUnitService.toFixed(2),
              };
            }
          );

          const isTatmeenRequired = item.is_tatmeen_required === 1 ||
            item.is_tatmeen_required === "1" ||
            item.is_tatmeen_required === true ||
            false;

          return {
            key: item.item_id,
            pur_d_id: item.pur_d_id || null,
            item_id: item.item_id,
            product: item.item_name,
            serial_mode: item.serial_mode || "unit",
            availableSerials: item.availableSerials || [],
            // selectedSerials: [],
            selectedSerials: [],
            return_qty: 0,
            pur_qty: item.pur_qty,
            invoice_qty: item.pur_qty,
            returned_qty: match ? match.total_return_qty : 0,
            invoice_remaining_qty: inv_qty,
            stock_available_qty: current_qty,
            available_qty: available_qty,
            // return_qty: 0,
            rate: item.item_rate,
            tax_per: item.item_tax_per,
            item_discount_per: item.item_discount_per,
            item_discount: item.item_discount,
            unit_symbol: item.unit_symbol,
            display_text: item.display_text,
            item_return_rate: Number(item.pur_rate) || Number(item.item_rate) || 0,
            discount_acc_id: item.discount_acc_id,
            discount_acc_name: item.discount_acc_name,
            item_total: item.item_total,
            per_symbol: item.unit_symbol,
            per_unit_id: item.per_unit_id,
            per_unit_symbol: item.per_unit_symbol,
            qty_display:
              item.item_qty +
              " " +
              item.unit_symbol +
              (item.conversion > 1
                ? ", " + item.retail_qty + " " + item.base_unit_name
                : ""),
            tax_acc_id: item.tax_acc_id,
            tax_acc_name: item.tax_acc_name,
            unit_name: item.unit_name,
            units: item.units,
            item_tax: item.item_tax,
            stock_avg_rate:
              average_rate_type === "yes" ? item.pur_avg_rate : item.pur_rate,
            ...match,
            //child_sscc_code: item.child_sscc_code || "",
            child_sscc_code: '',
            otherServiceTransactions,
            parentSsccCode,
            selected_batch_id: item.batch_id,
            is_tatmeen_required: isTatmeenRequired,
          };
        })
      );

      return { supplier, itemCart, masterData: data, otherServiceTrans };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Fetch existing record
export const fetchPurchaseReturnRecord = createAsyncThunk(
  "purchaseReturn/fetchRecord",
  async (pur_id, { rejectWithValue }) => {
    try {
      const res = await purchaseReturnWithDetailsApi({ pur_r_id: pur_id, mode: "single" }); //{ pur_r_id: pur_id }
      const data = res.data;
      if (!data) return null;

      const returnedRes = await getPurchaseReturnedItemsApi({
        pur_id: data.pur_id,                 // ✅ original purchase id
        exclude_pur_r_id: data.pur_r_id      // ✅ current return id
      });

      const itemCart = (data.details || []).map((item) => {
        // let serials = [];
        // if (item.is_serial === "yes" && item.serials) {
        //   serials = item.serials.split(",").map((slNo) => ({
        //     serial_number: slNo,
        //   }));
        // }
        // const selectedSerials =
        //   item.serials
        //     ? item.serials
        //       .split(",")
        //       .map(s => s.trim())
        //     : [];

        const returnedItems = returnedRes.data || [];

        const purchasedQty = Number(item.original_pur_qty || 0);
        const match = returnedItems.find(r => r.item_id === item.item_id);

        const invoiceQty = Number(item.original_pur_qty || 0);
        const returnedQty = match ? Number(match.total_return_qty) : 0;

        const availableQty = invoiceQty - returnedQty;
        const serials = item.serials
          ? item.serials.split(",").map(s => ({
            serial_number: s.trim(),
          }))
          : [];

        const selectedSerials = item.serials
          ? item.serials.split(",").map(s => s.trim())
          : [];

        const availableSerials = item.availableSerials || [];
        const isTatmeenRequired = item.is_tatmeen_required === 1 ||
          item.is_tatmeen_required === "1" ||
          item.is_tatmeen_required === true ||
          false;
          
        return {
          key: item.pur_r_d_id || Date.now(),
          pur_d_id: item.pur_d_id || null,
          item_id: item.item_id,
          product: item.item_name,
          availableSerials,
          selectedSerials,
          quantity: item.pur_r_qty || item.item_qty,
          rate: item.pur_r_rate || item.item_rate,
          discount: item.item_discount_per || 0,
          tax_per: item.item_tax_per || 0,
          serials,
          unit_name: item.unit_name,
          unit_symbol: item.unit_symbol,
          base_unit_name: item.base_unit_name,
          conversion: item.conversion,
          per_unit_id: item.per_unit_id,
          per_unit_symbol: item.per_unit_symbol,
          per_conversion: item.per_conversion,
          display_text: item.display_text,

          // available_qty: Math.max(purchasedQty - returnedQty, 0),
          invoice_qty: invoiceQty,
          returned_qty: returnedQty, // already returned before this return 
          available_qty: availableQty,
          return_qty: Number(item.pur_r_qty),
          item_return_rate: Number(item.pur_r_rate || item.item_rate || 0),
          tax_acc_id: item.tax_acc_id || "",
          item_tax: item.item_tax || 0,
          item_tax_per: item.item_tax_per || 0,
          pur_qty: item.original_pur_qty || item.pur_r_qty || 0,
          stock_avg_rate: item.pur_r_rate || item.item_rate || 0,
          discount_acc_id: item.discount_acc_id || "",
          selected_batch_id: item.batch_details_id,
          serial_mode:
            item.serial_mode || "unit",
          child_sscc_code: item.child_sscc_code || "",
          is_tatmeen_required: isTatmeenRequired,
        };
      });

      const parentSsccCode = data.sscc_code || data.original_sscc || '';

      // ✅ Get isTatmeen from record
      const isTatmeen = data.is_tatmeen_product === 1 || data.is_tatmeen === 1 || false;

      return { record: data, itemCart, trans: data.trans || [], parentSsccCode, isTatmeen };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Create or Update
export const createPurchaseReturn = createAsyncThunk(
  "purchaseReturn/create",
  async (pur_r_id, { getState, rejectWithValue }) => {
    try {
      const state = getState().purchaseReturn;
      const { auth } = getState();
      const payload = createPurchaseReturnPayload(state, auth.authInfo);

      let url = `/purchase/create-purchase-return`;
      if (pur_r_id) {
        url = `/purchase/update-purchase-return`;
      }

      const res = await postData(url, payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
